import React from "react";
import "./style/Loader.css";
import { classNames } from "../../helper/classNames";

const Loader = ({className}) => {
  return <div class={classNames("loader", className)}></div>;
};

export default Loader;
